module.exports = __webpack_public_path__ + "assets/images/16244907c7ed37d89ae8450d5b689199.png";